import { createContext } from "react";

export const CategoriasClienteContext = createContext()
export const CategoriasClienteFormContext = createContext()
export const CategoriasClienteReportContext = createContext()